import React, { useState, useEffect, useRef, useCallback } from 'react';
import 'swiper/css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useToast } from '../../Utils/toastContext';
import { useSelector, useDispatch } from 'react-redux';
import { debounce } from 'lodash';
import DocumentPreview from '../Create-Investment/documentpreview';
import Dropdown from '../../Components/CustomDropdown/customdropdown';
import CustomDropdownWithFetch from '../../Components/CustomDropdown/custom-dropdown-fetchAPI';
import { useRoutingNumberValidation } from '../../Components/bank-validations/use-routing-number-validation';

import {
  setUserProfilePic,
  setUserProfilePicDownloadUrl,
} from '../../Redux/store/userSlice';
import countriesData from '../../Data/CountryCodes.json';
import GeoRiskMap from '../../Components/addressInput/map-view';
import { formatDateTimeUTC } from '../../Constants/helper-functions';
import { MyBusinessScreen } from './my-business';
const validator = require('validator');

const MyProfile = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const userId = useSelector((state) => state.user.userId);
  const cardCurrencyName = useSelector((state) => state.user.cardCurrencyName);
  const roleName = useSelector((state) => state.user.roleName);
  const [copied, setCopied] = useState(false);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const [filter, setFilter] = useState('profile');
  const [isOpenEdit, setisOpenEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [currentBank, setcurrentBank] = useState({});
  const [isModalOpenBankEdit, setIsModalOpenBankEdit] = useState(false);
  const [newFirstName, setNewFirstName] = useState('');
  const [countries, setCountries] = useState([]);
  const getInitials = (name) => {
    if (!name) return '?';
    return name.trim().charAt(0).toUpperCase();
  };

  const getAvatarStyle = (name) => {
    const styles = [
      'bg-[#EEF2FF] text-[#3730A3] ring-1 ring-[#E0E7FF]', // Indigo soft
      'bg-[#F1F5F9] text-[#334155] ring-1 ring-[#E2E8F0]', // Slate
      'bg-[#FDF2F8] text-[#9D174D] ring-1 ring-[#FBCFE8]', // Rose subtle
      'bg-[#F0FDF4] text-[#166534] ring-1 ring-[#BBF7D0]', // Green subtle
      'bg-[#FFFBEB] text-[#92400E] ring-1 ring-[#FDE68A]', // Amber subtle
    ];

    const index = name?.charCodeAt(0) % styles.length;
    return styles[index];
  };
  const togglePopupEdit = () => {
    setisOpenEdit(!isOpenEdit);
    setcurrentPassword('');
    setnewPassword('');
    setconfirmPassword('');
    setShowConfirmPassword(false);
    setShowCurrentPassword(false);
    setShowNewPassword(false);
  };
  const [showconfirmPassword, setShowConfirmPassword] = useState(false);
  const [confirmPassword, setconfirmPassword] = useState('');
  const [showcurrentPassword, setShowCurrentPassword] = useState(false);
  const [currentpassword, setcurrentPassword] = useState('');
  const [transitError, setTransitError] = useState('');
  const [shownewPassword, setShowNewPassword] = useState(false);
  const [newPassword, setnewPassword] = useState('');
  const [isNewChangeFees, setisNewChangeFees] = useState(true);
  const [profileData, setprofileData] = useState({});
  const [accountAnalytics, setAccountAnalytics] = useState({});
  const [addressData, setAddressData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenProfile, setIsModalOpenProfile] = useState(false);
  const [countryCode, setCountryCode] = useState('AU');
  const [institutionNumber, setinstitutionNumber] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const [bankdata, setBankdata] = useState([
    {
      id: 0,
      bank_name: 'Test',
      account_name: 'Dummmy',
      account_number: null,
      bsb: null,
      swift: '082-356',
      branch_address: '333 George St, Sydney NSW 2000 Australia',
      currency: 'AUD',
    },
  ]);
  const [accountdata, setAccountData] = useState({
    no_of_active_accounts: 0,
    no_of_archieved_accounts: 0,
    active_accounts: {
      my_investments: 0,
    },
    archieved_accounts: {},
  });
  const [cardDatanew, setcardData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [isOpenEditCashAccount, setisOpenEditCashAccount] = useState(false);
  const [addressLine1, setAddressLine1] = useState('');
  const [addressLine2, setAddressLine2] = useState('');
  const [addressLine3, setAddressLine3] = useState('');
  const [toBsb, setToBsb] = useState('');
  const [toCurrency, setToCurrency] = useState('');
  const [toAccountName, setToAccountName] = useState('');
  const [preselectedcashCurrency, setpreselectedCurrency] = useState({
    value: 2,
    label: 'AUD',
  });
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: 'AU',
    label: 'Australia',
  });
  const [toAccountNumber, setToAccountNumber] = useState('');
  const [toBank, setToBank] = useState('');
  const [currencyData, setCurrencyData] = useState([]);
  const [swiftCode, setSwiftCode] = useState('');
  const [swiftError, setSwiftError] = useState('');
  const [transitNumber, setTransitNumber] = useState('');
  const [iban, setIban] = useState('');
  const fileInputRef = useRef(null);
  const [stream, setStream] = useState(null);
  const videoRef = useRef(null);
  const [showCamera, setShowCamera] = useState(false);
  const [animateCamera, setAnimateCamera] = useState(false);
  const canvasRef = useRef(null);
  const [preview, setPreview] = useState('');
  const [uploadPic, setUploadPic] = useState('');
  const profilePicURL = useSelector((state) => state.user.userProfilePic);
  const profilePicDownloadUrl = useSelector(
    (state) => state.user.userProfilePicDownloadUrl,
  );
  const [isModalOpenProfileEdit, setIsModalOpenProfileEdit] = useState(false);
  const [error, setError] = useState('');
  const [countryCodeProfile, setCountryCodeProfile] = useState('');
  const [customerType, setCustomerType] = useState('');
  const [newCity, setNewCity] = useState('');
  const [newState, setNewState] = useState('');
  const [newAddress, setNewAddress] = useState('');
  const [newZipCode, setNewZipCode] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [focus, setFocus] = useState(false);
  const [selectedCode, setSelectedCode] = useState('+61');
  const [newEmail, setNewEmail] = useState('');
  const [newLastName, setNewLastName] = useState('');
  const [preselectedCity, setpreselectedCity] = useState({});
  const [preselectedState, setpreselectedState] = useState({});
  const [cityData, setCityData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [bsbError, setBsbError] = useState('');

  const [preselectedCountryCodeProfile, setpreselectedCountryCodeProfile] =
    useState({});
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const { routingNumber, routingError, handleRoutingChange, setRoutingNumber } =
    useRoutingNumberValidation();
  const [totalCountExternalBank, setTotalCountExternalBank] = useState(0);
  const [totalPagesExternalBank, setTotalPagesExternalBank] = useState(0);
  const [currentPageExternalBank, setCurrentPageExternalBank] = useState(1);
  const [externalbankTable, setExternalbankTable] = useState([]);
  const [showRecordsExternalBank, setShowRecordsExternalBank] = useState(10);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const StatusRef = useRef();
  const [isOpenEditCashAccountBank, setIsOpenEditCashAccountBank] =
    useState(false);
  const [bankTab, setBankTab] = useState('');

  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: '10',
  });
  const filterOptions = [
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 30, label: '30' },
    { value: 50, label: '50' },
  ];
  const tabs = [
    { id: 'extBank', label: 'External Bank' },
    { id: 'thpBank', label: 'Third Party Bank' },
  ];
  const externalAccountHeaders = [
    { label: 'Date', key: '' },
    { label: 'Account Name', key: '' },
    { label: 'Account Number/IBAN', key: '' },
    { label: 'Account BSB', key: '' },
    { label: 'Bank Name', key: '' },
    { label: 'Other Details', key: '' },
    { label: 'Bank Address', key: '' },
    { label: 'Country Code', key: '' },
    { label: 'Status', key: '' },
    { label: 'Action', key: '' },
  ];
  const AllStatusFilters = [
    { value: null, label: 'ALL' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' },
    { value: 'pending', label: 'Pending' },
  ];
  const europeanCountryCodes = new Set([
    'AL',
    'AD',
    'AM',
    'AT',
    'AZ',
    'BY',
    'BE',
    'BA',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'GE',
    'DE',
    'GR',
    'HU',
    'IS',
    'IE',
    'IT',
    'KZ',
    'LV',
    'LI',
    'LT',
    'LU',
    'MT',
    'MD',
    'MC',
    'ME',
    'NL',
    'MK',
    'NO',
    'PL',
    'PT',
    'RO',
    'RU',
    'SM',
    'RS',
    'SK',
    'SI',
    'ES',
    'SE',
    'CH',
    'TR',
    'UA',
    'GB',
    'VA',
  ]);
  const handleBsbChange = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, '');
    setToBsb(numericValue);

    // Validation: must be 6 digits
    if (numericValue.length === 0) {
      setBsbError('BSB is required');
    } else if (numericValue.length !== 6) {
      setBsbError('BSB must be 6 digits');
    } else {
      setBsbError('');
    }
  };
  const handleTransitChange = (value) => {
    // Only allow digits
    const numericValue = value.replace(/\D/g, '');
    setTransitNumber(numericValue);

    // Validation: must be 5 digits
    if (numericValue.length === 0) {
      setTransitError('Transit number is required');
    } else if (numericValue.length !== 5) {
      setTransitError('Transit number must be 5 digits');
    } else {
      setTransitError('');
    }
  };
  const validateSwift = (value) => {
    const swiftRegex =
      /^[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
    return swiftRegex.test(value);
  };
  const handleSwiftChange = (e) => {
    const value = e.target.value.toUpperCase(); // optional: auto uppercase
    setSwiftCode(value);

    if (value && !validateSwift(value)) {
      setSwiftError('Invalid SWIFT/BIC format');
    } else {
      setSwiftError('');
    }
  };
  const handleshowRecordBank = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setShowRecordsExternalBank(parseInt(selectedOption.value));
    setCurrentPageExternalBank(1);
  };
  const getAllBanksDataAdmin = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/account/external-bank/list/external?limit=100&page=1&search=${searchQuery}`,
      );
      if (
        response.status == 200 &&
        response.data &&
        response.data.bank_accounts.length > 0
      ) {
        setExternalbankTable(response.data.bank_accounts);
      } else {
        setExternalbankTable([]);
      }
    } catch (err) {
      setExternalbankTable([]);
      showToast(err.message, 'error');
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const addThpBank = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let bodyData = {};
    let apiUrl = `${BASE_URL}/v1/merchant/dashboard/account/external-bank/add/external`;
    bodyData = {
      bank_name: toBank,
      account_number: toAccountNumber,
      account_bsb: toBsb,
      account_name: toAccountName,
      currency_id: toCurrency,
      address_line1: addressLine1,
      address_line2: addressLine2,
      address_line3: addressLine3,
      country_code: countryCode,
      swift_code: swiftCode,
      routing_number: routingNumber,
      institution_number: institutionNumber,
      transit_number: transitNumber,
      iban: iban,
      user_id: userId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleThirdPartyBank = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addThpBank();
        if (response.status == 201) {
          setisOpenEditCashAccount(false);
          getAllBanksDataAdmin();
          toastMessage = {
            message: 'Bank added successfully.',
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      toAccountName,
      toCurrency,
      toAccountNumber,
      toBsb,
      toBank,
      addressLine1,
      addressLine2,
      addressLine3,
      countryCode,
      userId,
      swiftCode,
      routingNumber,
      institutionNumber,
      transitNumber,
      iban,
    ], // Dependencies
  );
  const togglePopupAddBankCashAccount = () => {
    clearAllFieldsBank();
    setIsOpenEditCashAccountBank(!isOpenEditCashAccountBank);
  };
  const handleEditClickProfile = () => {
    setIsModalOpenProfileEdit(true);
    setNewFirstName(profileData.first_name);
    setNewLastName(profileData.last_name);
    setNewEmail(profileData.email_address);
    setMobileNumber(profileData.mobile_number);
    setSelectedCode(profileData.country_code);

    if (addressData && addressData.country) {
      setpreselectedCountryCodeProfile({
        value: addressData.country.id,
        label: addressData.country.name,
      });
      setCountryCodeProfile(addressData.country.id);
    }

    if (addressData && addressData.city) {
      setpreselectedCity({
        value: addressData.city.id,
        label: addressData.city.name,
      });
      setNewCity(addressData.city.id);
    }

    if (addressData && addressData.state) {
      setpreselectedState({
        value: addressData.state.id,
        label: addressData.state.name,
      });
      setNewState(addressData.state.id);
    }

    if (addressData) {
      setNewZipCode(addressData.zip_code);
      setNewAddress(addressData.google_address);
    }
  };
  // Step 2: Function to check if a code is European
  function isEuropeanCountry(code) {
    return europeanCountryCodes.has(code.toUpperCase());
  }
  const handleEditClickBank = (e, rowData) => {
    setcurrentBank(rowData.id);
    setIsModalOpenBankEdit(true);

    setToAccountName(rowData.account_name);
    if (rowData.country_code == null) {
      setCountryCode('AU');
      setCountryCodeEdit('AU');
    } else {
      setCountryCode(rowData.country_code);
      setCountryCodeEdit(rowData.country_code);
    }
    setToAccountNumber(rowData.account_number);
    setToBank(rowData.bank_name);

    if (rowData.currency == null) {
      setpreselectedCurrency({
        value: 2,
        label: 'AUD',
      });
      setToCurrency(2);
    } else {
      setpreselectedCurrency({
        value: rowData.currency.id,
        label: rowData.currency.name,
      });
      setToCurrency(rowData.currency.id);
    }

    setToBsb(rowData.account_bsb);
    setSwiftCode(rowData.swift_code);
    setRoutingNumber(rowData.routing_number);
    setTransitNumber(rowData.transit_number);
    setinstitutionNumber(rowData.institution_number);
    setIban(rowData.iban);
    setAddressLine1(rowData.address_line1);
    setAddressLine2(rowData.address_line2);
    setAddressLine3(rowData.address_line3);
  };
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const toggleConfirmPassword = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };
  const handleSelectCountryCodeProfile = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setCountryCodeProfile(selectedOption.value);
    setStateData([]);
    setCityData([]);
    setpreselectedCity({});
    setpreselectedState({});
  };
  const handleSelectCountryCode = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setCountryCode(selectedOption.value);
  };
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const handleProfileClick = () => {
    setIsModalOpenProfile(true);
  };
  const clearAllFieldsBank = () => {
    setToAccountName('');
    setpreselectedCurrency({ value: 2, label: 'AUD' });
    setpreselectedCountryCode({ value: 'AU', label: 'Australia' });
    setAddressLine1('');
    setToAccountNumber('');
    setToBank('');
    setAddressLine2('');
    setToBsb('');
    setCountryCode('AU');
    setToCurrency(2);
    setAddressLine3('');
    setSwiftCode('');
    setRoutingNumber('');
    setTransitNumber('');
    setIban('');
    setinstitutionNumber('');
  };
  const handleSelectToCurrency = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setToCurrency(selectedOption.value);
  };
  const fileUploadNew = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/user/upload/profile-image`;
    const formData3 = new FormData();
    formData3.append('profile_image', uploadPic); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const handleUploadFile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await fileUploadNew();
        if (response.status == 200) {
          handleCloseCamera();
          dispatch(setUserProfilePic(response.data.profile_image_url));
          dispatch(
            setUserProfilePicDownloadUrl(
              response.data.profile_image_url_download,
            ),
          );
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [uploadPic], // Dependencies
  );
  const handleSelectCity = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setNewCity(selectedOption.value);
  };
  const handleSelectState = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setNewState(selectedOption.value);
  };
  const editProfile = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/user/profile/update/${profileData.id}`;
    const bodyData = {
      first_name: newFirstName,
      last_name: newLastName,
      country_code: selectedCode,
      mobile_number: mobileNumber,
      email_address: newEmail,
      type: customerType,
      address: {
        city_id: newCity,
        country_id: countryCodeProfile,
        state_id: newState,
        zip_code: newZipCode,
        google_address: newAddress,
      },
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleEditProfile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await editProfile();
        if (response.status == 200) {
          setIsModalOpenProfileEdit(false);
          getprofileData();
          toastMessage = {
            message: 'Details updated successfully.',
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      newFirstName,
      newLastName,
      selectedCode,
      mobileNumber,
      newEmail,
      customerType,
      newCity,
      countryCodeProfile,
      newState,
      newZipCode,
      newAddress,
    ], // Dependencies
  );
  const addBank = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/account/external-bank/add`;
    const bodyData = {
      bank_name: toBank,
      account_number: toAccountNumber,
      account_bsb: toBsb,
      account_name: toAccountName,
      currency_id: toCurrency,
      address_line1: addressLine1,
      address_line2: addressLine2,
      address_line3: addressLine3,
      country_code: countryCode,
      swift_code: swiftCode,
      routing_number: routingNumber,
      institution_number: institutionNumber,
      transit_number: transitNumber,
      iban: iban,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleChangeIban = (e) => {
    const value = e.target.value.toUpperCase(); // IBANs are uppercase
    setIban(value);
  };
  const handleAddBank = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addBank();
        if (response.status == 200) {
          setisOpenEditCashAccount(false);
          setisOpenEdit(false);
          getBankData();

          toastMessage = {
            message:
              'Bank added successfully. Please check your authenticator app to verify the request and proceed',
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      toAccountName,
      toCurrency,
      toAccountNumber,
      toBsb,
      toBank,
      addressLine1,
      addressLine2,
      addressLine3,
      countryCode,
      userId,
      swiftCode,
      routingNumber,
      institutionNumber,
      transitNumber,
      iban,
    ], // Dependencies
  );
  const editBank = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/account/external-bank/update/${currentBank}`;
    const bodyData = {
      bank_name: toBank,
      account_number: toAccountNumber,
      account_bsb: toBsb,
      account_name: toAccountName,
      currency_id: toCurrency,
      address_line1: addressLine1,
      address_line2: addressLine2,
      address_line3: addressLine3,
      country_code: countryCode,
      user_id: userId,
      swift_code: swiftCode,
      routing_number: routingNumber,
      institution_number: institutionNumber,
      transit_number: transitNumber,
      iban: iban,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  function setCountryCodeEdit(countryCode) {
    const match = countryCodeData.find((c) => c.value === countryCode);
    if (match) {
      setpreselectedCountryCode({
        value: match.value,
        label: match.label,
      });
    } else {
      // Optional: set a default if no match found
      setpreselectedCountryCode({
        value: '',
        label: '',
      });
    }
  }
  const handleEditClick = (rowData) => {
    setcurrentBank(rowData.id);
    setIsModalOpenBankEdit(true);

    setToAccountName(rowData.account_name);
    if (rowData.country_code == null) {
      setCountryCode('AU');
      setCountryCodeEdit('AU');
    } else {
      setCountryCode(rowData.country_code);
      setCountryCodeEdit(rowData.country_code);
    }
    setToAccountNumber(rowData.account_number);
    setToBank(rowData.bank_name);

    if (rowData.currency == null) {
      setpreselectedCurrency({
        value: 2,
        label: 'AUD',
      });
      setToCurrency(2);
    } else {
      setpreselectedCurrency({
        value: rowData.currency.id,
        label: rowData.currency.name,
      });
      setToCurrency(rowData.currency.id);
    }
    setToBsb(rowData.account_bsb);
    setSwiftCode(rowData.swift_code);
    setRoutingNumber(rowData.routing_number);
    setTransitNumber(rowData.transit_number);
    setinstitutionNumber(rowData.institution_number);
    setIban(rowData.iban);
    setAddressLine1(rowData.address_line1);
    setAddressLine2(rowData.address_line2);
    setAddressLine3(rowData.address_line3);
  };
  const handleEditBank = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await editBank();
        if (response.status == 200) {
          setcurrentBank(null);
          setIsModalOpenBankEdit(false);
          if (bankTab == 'extBank') {
            getBankData();
          }
          if (bankTab == 'thpBank') {
            getAllBanksDataAdmin();
          }
          toastMessage = {
            message: 'Bank edited successfully.',
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      currentBank,
      toAccountName,
      toCurrency,
      toAccountNumber,
      toBsb,
      toBank,
      addressLine1,
      addressLine2,
      addressLine3,
      countryCode,
      userId,
      swiftCode,
      routingNumber,
      institutionNumber,
      transitNumber,
      iban,
    ], // Dependencies
  );
  const getAllCountryCode = async () => {
    try {
      const response = await GetAPIcalls(`/v1/user/country-codes`);

      if (response.status == 200) {
        let AllAccount = [];
        Object.entries(response.data).forEach(([key, value]) => {
          AllAccount.push({
            value: key,
            label: value,
          });
        });

        setCountryCodeData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      setCountryCodeData([]);
      setpreselectedCountryCode({});
      handleSelectCountryCode({});
      showToast(err.message, 'error');
    }
  };
  const getAllCountries = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/users/countries?size=1000`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.countries.forEach((item) => {
          AllAccount.push({
            value: item.id,
            label: item.name,
          });
        });

        setCountryData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      setCountryData([]);
      setpreselectedCountryCode({});
      handleSelectCountryCode({});
      showToast(err.message, 'error');
    }
  };
  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(' '); // Extract the date portion
    const [day, month, year] = datePart.split('/'); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };

  const getCities = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 20; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/cities/${countryCodeProfile}?page=${page}&size=${size}&search=${
          searchTerm || ''
        }`,
      );

      if (response.status === 200) {
        const items = response.data.cities.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        return {
          items,
          hasMore: response.data.cities.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, 'error');
      return { items: [], hasMore: false };
    }
  };
  const getStates = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 20; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/states/${countryCodeProfile}?page=${page}&size=${size}&search=${
          searchTerm || ''
        }`,
      );

      if (response.status === 200) {
        const items = response.data.states.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        return {
          items,
          hasMore: response.data.states.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, 'error');
      return { items: [], hasMore: false };
    }
  };

  const getAllStates = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/user/states/${countryCodeProfile}?size=200000`,
      );

      if (response.status == 200) {
        let AllAccount = [];
        response.data.states.forEach((item) => {
          AllAccount.push({
            value: item.id,
            label: item.name,
          });
        });

        setStateData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      setStateData([]);
      setpreselectedState({});
      showToast(err.message, 'error');
    }
  };
  const getAllCurrency = async () => {
    try {
      const response = await GetAPIcalls(`/v1/account/currencies`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.currencies.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
          });
        });

        setCurrencyData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const toggleCurrentPassword = () => {
    setShowCurrentPassword((prevState) => !prevState);
  };
  const toggleNewPassword = () => {
    setShowNewPassword((prevState) => !prevState);
  };
  const togglePopupAddTransactionCashAccount = () => {
    clearAllFieldsBank();
    setisOpenEditCashAccount(!isOpenEditCashAccount);
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const getprofileData = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(`/api/v1/users/me`);

      if (response.status == 200) {
        setprofileData(response.data);
        setAddressData(response.data.address);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          setprofileData({});
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
      setprofileData({});
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };
  const getBankData = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/account/external-bank/list?limit=100&search=${searchQuery}`,
      );

      if (response.status == 200) {
        setBankdata(response.data.banks);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          setBankdata([]);
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const getAccountData = async () => {
    setAccountData({
      no_of_active_accounts: 0,
      no_of_archieved_accounts: 0,
      active_accounts: {
        my_investments: 0,
      },
      archieved_accounts: {},
    });
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/profile/accounts`,
      );

      if (response.status == 200) {
        setAccountData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        if (response.status === 400) {
          setAccountData({});
          showToast(response.message, 'error');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };

  useEffect(() => {
    if (filter === 'profile') {
      getprofileData();
      getAllCountries();
    }
    if (filter === 'banks') {
      getAllCountryCode();
      getAllCurrency();
    }
    if (filter === 'accounts') {
      getAccountData();
    }
  }, [filter, bankTab]);
  useEffect(() => {
    if (filter === 'banks') {
      if (bankTab == 'extBank') {
        getBankData();
      }
      if (bankTab == 'thpBank') {
        getAllBanksDataAdmin();
      }
    }
  }, [filter, bankTab, searchQuery]);

  const UpdatePassword = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/merchant/dashboard/profile/change-password`;
    const bodyData = {
      old_password: currentpassword,
      new_password: newPassword,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'PUT',
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ['image/png', 'image/jpeg'];
    const maxSizeMB = 10;

    if (!validTypes.includes(file.type)) {
      showToast('Please upload an image in PNG or JPEG format.', 'error');
      return;
    }

    if (file.size > maxSizeMB * 1024 * 1024) {
      showToast('File size must be less than 10MB.', 'error');
      return;
    }
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setPreview(imageUrl);
      setUploadPic(file);
    }
  };
  const handleUpdatePassword = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UpdatePassword();

        if (response.status == 200) {
          togglePopupEdit();
          toastMessage = {
            message: 'Password Updated successfully!',
            type: 'success',
          };
        } else {
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [newPassword, currentpassword], // Dependencies
  );
  function formatDateTime(dateString) {
    if (!dateString) return '-';

    try {
      // remove timezone abbreviations like AEDT, AEST etc.
      const cleaned = dateString.replace(/\b[A-Z]{3,4}\b/g, '').trim();

      const parts = cleaned.split(' ');
      const [day, month, year] = parts[0].split('/');

      let [hour, min, sec] = parts[1].split(':');
      const period = parts[2];

      hour = parseInt(hour);

      // convert 12h → 24h
      if (period === 'PM' && hour !== 12) hour += 12;
      if (period === 'AM' && hour === 12) hour = 0;

      return `${day}/${month}/${year}`;
    } catch (e) {
      return '-';
    }
  }
  const startCamera = async () => {
    setPreview('');
    setUploadPic(null);
    setShowCamera(true);

    setTimeout(() => setAnimateCamera(true), 10); // trigger fade-in animation
    try {
      const newStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });
      setStream(newStream);
    } catch (err) {
      console.error('Camera access error:', err);
    }
  };
  const handleTakeSnap = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0);
    const dataUrl = canvas.toDataURL('image/png');
    setPreview(dataUrl);
    fetch(dataUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], 'photo.png', { type: 'image/png' });
        setUploadPic(file); // now you can send this file to API
      });
    // cleanup
    //handleCloseCamera();
  };
  const handleCloseCamera = () => {
    setAnimateCamera(false); // start fade-out
    setTimeout(() => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        setStream(null);
      }
      setShowCamera(false); // hide modal after animation
    }, 300); // match duration-300
  };
  // assign stream to video after it's rendered
  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
      videoRef.current.play();
    }
  }, [stream]);
  return (
    <div className="w-full">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {roleName !== 'agency' && (
        <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
          <div className="w-full p-4 bg-white rounded-lg shadow-lg">
            {/* Header Section */}
            <div className="flex w-full  flex-col md:flex-row justify-between items-start md:items-center border-b pb-5 border-gray-100">
              <div className="flex items-center mb-2 md:mb-0">
                <img
                  src="/profile-circle-black.svg"
                  alt="Company Logo"
                  className="mr-3 w-6 h-6"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Business Details
                </span>
              </div>
              <p className="text-sm">
                <span className="font-medium text-labelLightColour">
                  Member since:{' '}
                </span>
                <span className="font-medium text-black">
                  {formatDateTimeUTC(profileData.created_at)}
                </span>
                {/* <button
                onClick={() => handleEditClickProfile()}
                className="  right-4 px-3 rounded-md text-sm transition-colors duration-200"
              >
                <img
                  src="/edit-details.svg" // Replace with the actual path to your edit icon
                  alt="Edit Icon"
                  className="w-4 h-4 cursor-pointer"
                />
              </button> */}
              </p>
            </div>
            {isModalOpenProfileEdit && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                  {/* Modal Header */}
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg font-medium text-center w-full">
                        Edit Personal Details
                      </h2>
                      <div className="flex justify-end">
                        <img
                          onClick={() => {
                            setIsModalOpenProfileEdit(false);
                          }}
                          src="/add.svg"
                          alt="Add"
                          className="w-10 h-10 cursor-pointer"
                        />
                      </div>
                    </div>
                    <div className="grid px-4 grid-cols-1 md:grid-cols-2 gap-6">
                      {/* Left Column */}
                      <div className="space-y-4 pt-4 px-4">
                        {/* Code */}
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            {roleName === 'agency' || roleName === 'business'
                              ? 'Full Name'
                              : 'First Name'}
                          </label>{' '}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newFirstName}
                            onChange={(e) => setNewFirstName(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="John"
                          />
                        </div>
                        {roleName === 'agency' && roleName === 'business' && (
                          <div>
                            <label
                              htmlFor="finInstituition"
                              className="mb-1 text-sm text-labelColour"
                            >
                              Last Name
                            </label>{' '}
                            <input
                              id="finInstituition"
                              type="text"
                              value={newLastName}
                              onChange={(e) => setNewLastName(e.target.value)}
                              className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                              placeholder="Daniel"
                            />
                          </div>
                        )}
                      </div>
                      {/* Center Column with Border */}
                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l border-gray-300 px-4">
                        <div className="mb-4">
                          <label
                            htmlFor="mobileNumber"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Mobile Number
                          </label>
                          <div className="flex  items-center">
                            <select
                              value={selectedCode}
                              onChange={handleCodeChange}
                              onFocus={() => setFocus(true)}
                              onBlur={() => setFocus(false)}
                              className={` appearance-none text-code font-medium input-field-mobilecode rounded-md px-2  ${
                                focus
                                  ? 'border-black border-2'
                                  : 'border-gray-300 border'
                              } border-r-0 leading-tight focus:outline-none `}
                              placeholder="AU+61"
                            >
                              {countries.map((country) => (
                                <option
                                  key={country.code}
                                  value={country.dialCode}
                                >
                                  {country.code} {country.dialCode}
                                </option>
                              ))}
                            </select>
                            <input
                              type="tel"
                              id="mobileNumber"
                              value={mobileNumber}
                              onFocus={() => setFocus(true)}
                              onBlur={() => setFocus(false)}
                              onChange={(e) => setMobileNumber(e.target.value)}
                              placeholder="Mobile Number"
                              className={`border  text-black text-base font-medium input-field-mobile px-2 ${
                                focus
                                  ? 'border-black border-2'
                                  : 'border-gray-300 border'
                              } rounded-md focus:outline-none w-full border-l-0 appearance-none`}
                            />
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Email
                          </label>{' '}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newEmail}
                            onChange={(e) => setNewEmail(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Your Email"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                      <h1 className="text-md font-medium mb-2 text-center">
                        Location Details
                      </h1>
                    </div>{' '}
                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                      {/* Left Column */}
                      <div className="space-y-4 pt-4 px-4">
                        <div className="">
                          <Dropdown
                            label="Select Country"
                            options={countryData}
                            search={true}
                            preselectedValue={preselectedCountryCodeProfile}
                            onSelect={handleSelectCountryCodeProfile}
                            colorLabel=""
                          />
                        </div>
                        <div>
                          <CustomDropdownWithFetch
                            label="Select City"
                            options={cityData}
                            search={true}
                            preselectedValue={preselectedCity}
                            onSelect={handleSelectCity}
                            colorLabel=""
                            fetchOptions={getCities} // <-- pass fetch function, not options
                          />
                          {/* <input
                            id="finInstituition"
                            type="text"
                            value={newCity}
                            onChange={(e) => setNewCity(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Sydney..."
                          /> */}
                        </div>
                      </div>

                      {/* Center Column with Border */}
                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                        <div>
                          <CustomDropdownWithFetch
                            label="Select State"
                            options={stateData}
                            search={true}
                            preselectedValue={preselectedState}
                            onSelect={handleSelectState}
                            colorLabel=""
                            fetchOptions={getStates} // <-- pass fetch function, not options
                          />
                          {/* <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            State
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newState}
                            onChange={(e) => setNewState(e.target.value)}
                            className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="NSW"
                          /> */}
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Zip Code
                          </label>{' '}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newZipCode}
                            onChange={(e) => setNewZipCode(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Apartment unit 2 etc..."
                          />
                        </div>
                      </div>

                      {/* Right Column */}
                      <div className="space-y-4 px-4 pt-4">
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Address
                          </label>{' '}
                          <textarea
                            id="finInstituition"
                            type="text"
                            value={newAddress}
                            onChange={(e) => setNewAddress(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Apartment unit 2 etc..."
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                      <button
                        onClick={() => {
                          setIsModalOpenProfileEdit(false);
                        }}
                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          if (!validateEmail(newEmail)) {
                            showToast('Enter the valid email', 'error');
                            return;
                          }
                          if (
                            !validator.isMobilePhone(
                              selectedCode + mobileNumber,
                              'any',
                            )
                          ) {
                            console.log('country code ' + selectedCode);
                            console.log('mobile number is ' + mobileNumber);
                            console.log(
                              validator.isMobilePhone(
                                selectedCode + mobileNumber,
                                'any',
                              ),
                            );
                            showToast(
                              'Please enter valid mobile number',
                              'error',
                            );
                            return;
                          }
                          if (
                            !newFirstName ||
                            !newLastName ||
                            !newEmail ||
                            !selectedCode ||
                            !mobileNumber ||
                            !newCity ||
                            !newState ||
                            !newZipCode ||
                            !newAddress ||
                            !countryCodeProfile
                          ) {
                            showToast('Please Add all fields', 'error');
                            return;
                          }
                          setLoading(true);
                          handleEditProfile(e);
                        }}
                        className="px-6 py-2 rounded-lg bg-[#375AE7] text-white hover:bg-gray-800"
                      >
                        Update Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Profile Section */}
            <div className="flex w-full flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
              {/* Profile Picture */}
              <div className="relative flex flex-col sm:flex-row items-center gap-4 mb-4 lg:mb-0">
                {/* Profile Picture */}
                <div className="relative">
                  {profileData?.profile_picture?.presigned_url ? (
                    <img
                      src={profileData.profile_picture.presigned_url}
                      alt={`${profileData.first_name}`}
                      className="w-14 h-14 rounded-full object-cover"
                    />
                  ) : (
                    <div
                      className={`w-14 h-14 flex items-center justify-center rounded-full font-semibold text-sm ${getAvatarStyle(
                        profileData.first_name,
                      )}`}
                    >
                      {getInitials(profileData.first_name)}
                    </div>
                  )}
                  {profileData.status?.label === 'active' && (
                    <div className="absolute top-2 left-12 w-3 h-3 bg-[#75E380] rounded-full"></div>
                  )}
                  {profileData.status?.label === 'rejected' && (
                    <div className="absolute top-2 left-12 w-3 h-3 bg-[#FF5050] rounded-full"></div>
                  )}
                  {roleName === 'customer' && (
                    <>
                      <label className="mt-2 text-xs text-center">
                        <span className="text-[#A6A6A6]">Client No:</span>
                      </label>

                      <div className="flex items-center justify-center gap-2">
                        <p className="text-black text-sm text-center font-medium">
                          {profileData.client_id}
                        </p>

                        {/* Copy Button */}
                        <button
                          onClick={() => {
                            navigator.clipboard.writeText(
                              profileData.client_id,
                            );
                            setCopied(true);
                            setTimeout(() => setCopied(false), 1500);
                          }}
                          className="flex items-center justify-center p-1 rounded-md hover:bg-gray-200 transition"
                          title="Copy Client ID"
                        >
                          <span className="material-symbols-outlined text-lg text-gray-600">
                            content_copy
                          </span>
                        </button>
                      </div>

                      {/* Feedback */}
                      {copied && (
                        <p className="text-green-600 text-xs text-center mt-1 animate-pulse">
                          Copied!
                        </p>
                      )}
                    </>
                  )}
                </div>

                {/* Buttons */}
                <div className="flex flex-col space-y-2 mb-4">
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                  />
                  {/* <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleProfileClick();
                  }}
                  className="bg-white text-black border-black border-2 text-xs px-3 py-1 rounded-full whitespace-nowrap"
                >
                  View Picture
                </button> */}
                  {/* <button
                  onClick={startCamera}
                  className="bg-[#375AE7] text-white text-xs px-3 py-1 rounded-full flex items-center justify-center gap-2 whitespace-nowrap"
                >
                  <img
                    src="/camera-black.svg"
                    alt="Camera Icon"
                    className="w-4 h-4"
                  />
                  Edit Picture
                </button> */}
                </div>
              </div>

              {/* Profile Details */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full ">
                {/* Column 1 */}
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <label
                    htmlFor="refId"
                    className="mb-1 text-xs text-[#A6A6A6]"
                  >
                    Status
                  </label>
                  <span className="text-sm">
                    {profileData?.status?.label
                      .replace(/_/g, ' ')
                      .replace(/\b\w/g, (char) => char.toUpperCase())}
                  </span>
                  {profileData.type !== 'Corporate' && (
                    <>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          {roleName === 'agency' || roleName === 'business'
                            ? 'Full Name'
                            : 'First Name'}
                        </label>
                        <div className="text-sm">{profileData.first_name}</div>
                      </div>
                      {roleName !== 'agency' && roleName !== 'business' && (
                        <div className="mt-4">
                          <label
                            htmlFor="investmentType"
                            className="mb-1 text-xs text-[#A6A6A6]"
                          >
                            Last Name
                          </label>
                          <div className="text-sm">{profileData.last_name}</div>
                        </div>
                      )}
                    </>
                  )}

                  {profileData.type === 'Corporate' && (
                    <>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          Company Name
                        </label>
                        <div className="text-sm">
                          {profileData.first_name} {profileData.last_name}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Column 2 */}
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <label
                    htmlFor="investmentManagerFees"
                    className="mb-1 text-xs"
                  >
                    <span className="text-[#A6A6A6]">Phone</span>
                  </label>
                  <div className="text-sm">
                    {profileData.country_code}
                    {profileData.mobile_number}
                  </div>
                  {profileData.type !== 'Corporate' && (
                    <>
                      <label
                        htmlFor="investmentManagerFees"
                        className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                      >
                        Email
                      </label>
                      <span className="text-sm">
                        {profileData.email_address}
                      </span>
                    </>
                  )}
                  {roleName !== 'agency' &&
                    roleName !== 'business' &&
                    roleName !== 'agent' &&
                    roleName !== 'agency_compliance' &&
                    roleName !== 'auditor' && (
                      <>
                        {' '}
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                        >
                          Type
                        </label>
                        <div className="text-sm">
                          {profileData?.account_type?.name}
                        </div>
                      </>
                    )}
                </div>

                {/* Column 3 */}
                {/* {profileData.type !== "Corporate" && (
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <label
                    htmlFor="investmentManagerFees"
                    className="mb-1 text-xs"
                  >
                    <span className="text-[#A6A6A6]">Password</span>
                  </label>
                  <div className="text-sm">{profileData.password}</div>
                  <button
                    onClick={togglePopupEdit}
                    className="mt-4 py-3 w-40 bg-[#375AE7] text-white text-sm rounded-md hover:bg-gray-800"
                  >
                    Change Password
                  </button>
                </div>
              )} */}
                {isOpenEdit && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[700px] p-6">
                      {/* Modal Header */}
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-medium text-center w-full">
                          Change Password
                        </h2>
                        <button onClick={togglePopupEdit}>
                          <img
                            src="/add.svg"
                            alt="Close"
                            className="w-10 h-10"
                          />
                        </button>
                      </div>

                      {/* Modal Body */}
                      <div className="grid grid-cols-1 gap-6 items-center">
                        <div className="space-y-4 mx-auto ">
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                            >
                              Current password
                            </label>
                            <input
                              type={showcurrentPassword ? 'text' : 'password'}
                              value={currentpassword}
                              required={true}
                              id="currentpassword"
                              onChange={(e) =>
                                setcurrentPassword(e.target.value)
                              }
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleCurrentPassword}
                              className="absolute right-3 set-top"
                            >
                              {' '}
                              {showcurrentPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                            >
                              New password
                            </label>
                            <input
                              type={shownewPassword ? 'text' : 'password'}
                              value={newPassword}
                              required={true}
                              id="newpassword"
                              onChange={(e) => setnewPassword(e.target.value)}
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleNewPassword}
                              className="absolute right-3 set-top"
                            >
                              {' '}
                              {shownewPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block color-test dark:text-gray-300 font-normal color-test text-md mb-1"
                            >
                              Repeat password
                            </label>
                            <input
                              type={showconfirmPassword ? 'text' : 'password'}
                              value={confirmPassword}
                              required={true}
                              id="confirmpassword"
                              onChange={(e) =>
                                setconfirmPassword(e.target.value)
                              }
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleConfirmPassword}
                              className="absolute right-3 set-top"
                            >
                              {' '}
                              {showconfirmPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Modal Footer */}
                      <div className="flex justify-center space-x-4 mt-6">
                        <button
                          onClick={togglePopupEdit}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (newPassword.length < 8) {
                              showToast(
                                'Password must have At least 8 characters',
                                'error',
                              );
                              return;
                            }
                            if (!/(?=.*[0-9])/.test(newPassword)) {
                              showToast(
                                'Password must have At least 1 number',
                                'error',
                              );

                              return;
                            }
                            if (
                              !/(?=.*[!@#$%^&*()_+={}\[\]|:;"'<>,.?/`~\\/-])/.test(
                                newPassword,
                              )
                            ) {
                              showToast(
                                'Password must have At least 1 special character',
                                'error',
                              );

                              return;
                            }
                            if (!(
                              /(?=.*[a-z])/.test(newPassword) &&
                              /(?=.*[A-Z])/.test(newPassword)
                            )) {
                              showToast(
                                'Password must have Both upper and lower case characters',
                                'error',
                              );

                              return;
                            }
                            if (newPassword !== confirmPassword) {
                              showToast(
                                'Confirm password should be same as password',
                                'error',
                              );

                              return;
                            }
                            if (newPassword === currentpassword) {
                              showToast(
                                'New password should be different from current password',
                                'error',
                              );
                              return;
                            }
                            setLoading(true);
                            handleUpdatePassword(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-[#375AE7] text-white hover:bg-gray-800"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <canvas ref={canvasRef} className="hidden" />
          {isModalOpenProfile && profilePicURL && (
            <DocumentPreview
              fileUrl={profilePicDownloadUrl}
              fileName={profilePicURL.split('/').pop().split('?')[0]}
              onClose={() => setIsModalOpenProfile(false)}
            />
          )}
          <div className="pt-4 lg:flex mb-4 lg:space-x-4 gap-4">
            {/* LOCATION CARD */}
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 w-full lg:flex-[1.5]">
              {/* HEADER */}
              <div className="flex justify-between items-center border-b pb-3">
                <div className="flex items-center space-x-3">
                  <span className="text-lg">📍</span>
                  <h3 className="text-sm font-semibold text-gray-800">
                    Location details
                  </h3>
                </div>
              </div>

              {/* CONTENT */}
              {addressData && (
                <div className="grid md:grid-cols-1 gap-4 mt-4">
                  {/* PROVIDED ADDRESS (single-line from API) */}
                  <div className="p-4 rounded-xl bg-gray-50 border">
                    <p className="text-[11px] text-gray-500 mb-2">
                      PROVIDED ADDRESS
                    </p>

                    <div className="space-y-2 text-xs text-gray-700">
                      <div className="text-sm break-words">
                        {addressData?.google_address ||
                          [
                            addressData?.address_line_1,
                            addressData?.address_line_2,
                            addressData?.address_line_3,
                          ]
                            .filter(Boolean)
                            .join(', ')}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* MAP SECTION */}
              {/* <div className="mt-5">
                <p className="text-xs text-gray-500 mb-2">Location map</p>

                <div className="relative w-full h-[220px] rounded-xl overflow-hidden border bg-gradient-to-br from-blue-50 via-white to-gray-50 flex items-center justify-center">
                  <GeoRiskMap
                    currentLocation={
                      addressData?.lat != null && addressData?.lng != null
                        ? {
                            lat: Number(addressData.lat),
                            lng: Number(addressData.lng),
                          }
                        : null
                    }

                    addressString={addressData?.google_address}
                  />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      )}
      {roleName === 'agency' && <MyBusinessScreen />}
    </div>
  );
};

export default MyProfile;
